<div #chartContainer class="chart-container"></div>

<div class="skills-counter" layout-vertical layout-align-items-center>
  @if (isHidden() || isEmpty()) {
    <div text-large text-disabled text-bold>{{ isHidden() ? '∗∗∗' : '—' }}</div>
    <div text-light [style.font-size.px]="labelFontSize()">
      {{ 'app.interview.summary.skills_summary.skills' | translate }}
    </div>
  } @else {
    <div text-large text-darkest text-bold>
      {{ skills().matchingSkillsCount }}/{{ skills().skillsCount }}
    </div>
    <div text-light [style.font-size.px]="labelFontSize()">
      {{ 'app.interview.summary.skills_summary.skills' | translate }}
    </div>
  }
</div>
